import {
  createContext,
  Dispatch,
  PropsWithChildren,
  useContext,
  useReducer,
} from 'react';
import { useSearchParams } from 'react-router-dom';
interface ContextValue {
  state: any;
  dispatch: Dispatch<any>;
  isFiltering: boolean;
}

const FiltersListContext = createContext<ContextValue | undefined>(undefined);

export function useFiltersListContext() {
  const value = useContext(FiltersListContext);
  if (value === undefined) {
    throw new Error('useFiltersList must be used within a FiltersListContext');
  }
  return value;
}

export function FiltersListProvider({ children }: PropsWithChildren) {
  const [urlSearchParams, setUrlSearchParams] = useSearchParams();

  const reducer = (
    _state: Record<string, unknown>,
    action: { name: string; value: unknown }
  ) => {
    const prevState = JSON.parse(urlSearchParams.get('params') ?? '{}');

    let newState = { ...prevState };

    const hasValue = Array.isArray(action.value)
      ? action.value.length > 0
      : !!action.value;

    if (hasValue) {
      newState = { ...prevState, [action.name]: action.value };
    } else {
      delete newState[action.name];
    }

    setUrlSearchParams(
      (prev) => {
        const params = new URLSearchParams(prev);
        params.set('params', JSON.stringify(newState));
        return params;
      },
      { replace: true }
    );

    return newState;
  };

  const [state, dispatch] = useReducer(
    reducer,
    JSON.parse(urlSearchParams.get('params') ?? '{}')
  );

  const isFiltering = Object.keys(state).length > 0;

  return (
    <FiltersListContext.Provider
      value={{
        state,
        isFiltering,
        dispatch,
      }}
    >
      {children}
    </FiltersListContext.Provider>
  );
}
